import { render, staticRenderFns } from "./OrderBrief.vue?vue&type=template&id=26997310&scoped=true&"
import script from "./OrderBrief.vue?vue&type=script&lang=js&"
export * from "./OrderBrief.vue?vue&type=script&lang=js&"
import style0 from "./OrderBrief.vue?vue&type=style&index=0&id=26997310&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26997310",
  null
  
)

export default component.exports